import { Routes } from '@angular/router';
import {authGuard} from './core/auth-guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./features/shared/unauthorized/unauthorized').then(m => m.Unauthorized),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./features/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'chart',
        loadComponent: () => import('./features/chart/chart').then(m => m.Chart)
      }
    ]
  }
];
